import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import type { AuthContextType } from "@/hooks/AuthContext";

interface RootRouterContext {
  auth: AuthContextType;
}

export const Route = createRootRouteWithContext<RootRouterContext>()({
  component: () => (
    <>
      <div className="min-h-screen bg-background">
        <Outlet />
      </div>
      {import.meta.env.DEV ? <TanStackRouterDevtools /> : null}
    </>
  ),
});
